import { LoginPresentation, TPropsForLoginPage } from '@/components/pages/login/LoginPresentation';
import { getServerSidePropsForLoginPage } from '@/pages/login';

const Index = (props: TPropsForLoginPage) => (
  <LoginPresentation accountName={props.accountName} password={props.password} />
);

export const getServerSideProps = getServerSidePropsForLoginPage;

export default Index;
